import {useSelector} from 'react-redux';

import {RELEASE_NOTES} from '/enum/popover.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {generateCallback} from '/util/component.util';

import {FeedbackSectionProps} from './FeedbackSection.types';

export const useFeedbackSection = ({
  onFeedbackPress = () => {},
}: FeedbackSectionProps) => {
  const {tt} = useTranslation('screen.profile.feedback');
  const featureFlag = useSelector(variablesFeatureFlag);

  const showReleaseNotes = generateCallback({
    func: onFeedbackPress,
    params: RELEASE_NOTES,
  });

  return {tt, showReleaseNotes, featureFlag};
};
